import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { Observable, distinctUntilChanged, map } from 'rxjs';
import { PlaceValue, ScreenSize } from 'src/app/core/constants/types.constants';
import { getPlaceValue } from 'src/app/core/functions/utility';
import { CoinDetail } from 'src/app/core/models/coin.model';

@Component({
    selector: 'app-coin-overview',
    templateUrl: './coin-overview.component.html',
    styleUrls: ['./coin-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoinOverviewComponent implements OnInit {
    @Input() coinDetail!: CoinDetail;
    @Input() usdExchangeRate: number = 1;
    @Input() currencySymbol: string = 'USD';

    volumeByMarketCap!: string;
    progressBarValue!: number | null;
    progressPercent!: string;

    coinOverviewObs!: Observable<ScreenSize>;

    private breakpointObserver = inject(BreakpointObserver);

    ngOnInit(): void {
        this.initCoinData();

        this.coinOverviewObs = this.breakpointObserver
            .observe(['(min-width: 0px) and (max-width: 767px)', '(min-width: 768px)'])
            .pipe(
                distinctUntilChanged(),
                map(_ => {
                    let screen: ScreenSize = 'desktop';
                    if (this.breakpointObserver.isMatched('(min-width: 0px) and (max-width: 767px)')) screen = 'mobile';
                    if (this.breakpointObserver.isMatched('(min-width: 768px)')) screen = 'desktop';
                    return screen;
                })
            );
    }

    initCoinData() {
        /* Calculate Volume/Market Cap Ratio */
        if (this.coinDetail.mc) {
            this.volumeByMarketCap = (this.coinDetail.volume / this.coinDetail.mc).toFixed(8).replace(/\.?0+$/, '');
        } else this.volumeByMarketCap = '--';

        /* Calculate Progress Bar Value and it's percentage */
        if (this.coinDetail.supply.max_supply) {
            this.progressBarValue = (this.coinDetail.cs * 100) / this.coinDetail.supply.max_supply;
            const fixPrecision = this.progressBarValue.toPrecision(2);
            if (+fixPrecision === 100) this.progressPercent = '100%';
            else this.progressPercent = this.progressBarValue.toPrecision(2) + '%';
        } else this.progressBarValue = null;
    }

    getPlaceValueNotation(value: number): PlaceValue {
        return getPlaceValue(value);
    }
}
